var _path, _path2, _circle, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFailure = function SvgFailure(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg869",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2076",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5,
    d: "M5.331 29.896A17.883 17.705 0 0 1 .78 17.039 17.883 17.705 0 0 1 6.8 4.788"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path2356",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5,
    d: "M-30.686 29.896a17.883 17.705 0 0 1-4.551-12.857 17.883 17.705 0 0 1 6.02-12.251",
    transform: "scale(-1 1)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "path2380",
    cx: 18,
    cy: 18,
    r: 14,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect2484",
    width: 3,
    height: 10.7,
    x: 16.5,
    y: 9.3,
    fill: "currentColor",
    ry: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "rect2632",
    width: 3,
    height: 3,
    x: 16.5,
    y: 22.5,
    fill: "currentColor",
    ry: 1
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFailure);
export default ForwardRef;